<template>
	<div class="role_authority">
		<div v-wechat-title="$route.meta.title"></div>
		<!--TopBar></TopBar-->

		<div style="display: flex; justify-content: center; position: relative; left: 50%; transform: translate(-50%); margin-top: 0px;">
			<!-- 角色栏 -->
			<RoleList ref="role" :logList="logList" :roleList="roleList" @changeActiveId="changeActiveId" @getMemberList="getMemberList" @loadData="loadData"></RoleList>
			<!-- 权限栏 -->
			<Jurisdiction :activeId="activeId" @loadData="loadData"></Jurisdiction>
			<!-- 包含成员栏 -->
			<Member :memberList="memberList"></Member>
		</div>
	</div>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex';
	import RoleList from './RoleList.vue'
	import Jurisdiction from './Jurisdiction.vue'
	import Member from './Member.vue'
	import TopBar from '../topbar/TopBar.vue'
	import {
		getRoleList,getUserByRole,getRoleLog
	} from '@/api/user'
	export default {
		name: "RoleAuthority",
		components: {RoleList,Jurisdiction,Member,TopBar},
		data() {
			return {
				roleList: [],
				memberList: [],
				logList: [],
				activeId: 0,
			}
		},
		computed:{
			...mapGetters(['userInfo', 'token'])
		},
		mounted: function() {
			this.loadData();
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			async loadData() {
				let that = this;
				let data = {token: this.token};
				var res = await getRoleList(that, data);
				if (res.code == 1) {
					that.roleList = res.data.list;
					that.activeId = res.data.list[0].id;
					that.$refs['role'].activeId = res.data.list[0].id
					that.getMemberList();
				}
				var res = await getRoleLog(that, data);
				that.logList = res.data.list;
			},
			async changeActiveId() {
				this.activeId = this.$refs['role'].activeId;
			},
			async getMemberList() {
				let that = this;
				let data = {token: this.token};
				data.id = that.$refs['role'].activeId;
				let res = await getUserByRole(that, data);
				if (res.code == 1) {
					that.memberList = res.data.list;
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.role_authority{
		width: 100%;
		min-height: 100%;
		background-color: #F5F7F9;
	}

</style>
